import { gql } from "@apollo/client";
import { TRAVEL_BOOKING_UPSELL_FIELDS, TRAVEL_UPSELL_DESTINATION_FIELDS, TRAVEL_UPSELL_FIELDS } from "./fragments";

export const GET_TRAVEL_UPSELLS = gql`
  query GetTravelUpsells(
    $searchTerm: String
    $includeInactive: Boolean! = false
    $pageSize: Int! = 50
    $pageNumber: Int! = 0
  ) {
    travelUpsells(searchTerm: $searchTerm, includeInactive: $includeInactive, pageSize: $pageSize, pageNumber: $pageNumber) {
      count
      pageSize
      pageNumber
      items {
        ${TRAVEL_UPSELL_FIELDS}
      }
    }
  }
`;

export const GET_TRAVEL_UPSELL = gql`
  query GetTravelUpsell($id: String!) {
    travelUpsell(id: $id) {
      ${TRAVEL_UPSELL_FIELDS}
    }
  }
`;

export const GET_TRAVEL_UPSELL_PREVIEW = gql`
  query GetTravelUpsellPreview($request: TravelUpsellRequestInput!, $saleOrderCode: String!, $locale: String) {
    travelUpsellPreview(request: $request, saleOrderCode: $saleOrderCode, locale: $locale) {
      id
      conditionsMatch
      upsell {
        ${TRAVEL_BOOKING_UPSELL_FIELDS}
      }
    }
  }
`;

export const GET_TRAVEL_UPSELL_DESTINATIONS = gql`
  query GetTravelUpsellDestinations {
    travelUpsellDestinations {
      ${TRAVEL_UPSELL_DESTINATION_FIELDS}
    }
  }
`;

export const GET_TRAVEL_UPSELL_TOUR_DESTINATION_SUGGESTIONS = gql`
  query GetTravelUpsellTourDestinationSuggestions($term: String!) {
    travelUpsellTourDestinationSuggestions(term: $term) {
      id
      destinationId
      name
      countryCode
      type
    }
  }
`;

export const GET_TRAVEL_UPSELL_HOTEL_DESTINATION_SUGGESTIONS = gql`
  query GetTravelUpsellHotelDestinationSuggestions($term: String!) {
    travelUpsellHotelDestinationSuggestions(term: $term) {
      id
      destinationId
      name
      countryCode
      type
    }
  }
`;
